import { createAPI } from '@common'

export default {
  // 互动公共内容列表
  gePublicContentList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qvcDpoufou', 'get', config),
  // 当前用户最近使用的互动公共内容列表
  getPublicContentCommonPhrases: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qvcDpoufou0mbtu', 'get', config),
  // 删除互动公共内容
  deletePublicContent: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qvcDpoufou0efmfuf', 'get', config),
  // 新建互动公共内容
  postPublicContent: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qvcDpoufou', 'post', config),
}
